<template>
  <div class="assetcenter">
    <Freezes ref="freezes" />
    <Award ref="award" :maxmoney="assets.AwardAvailableAmount" />
    <div class="assetmain">
      <div class="header">
        <p class="name">
          Hi,
          <span>{{userinfo.RealName}}</span>
        </p>
        <div class="id">
          <span>UID:{{assets.OwerId}}</span>
          <span>|</span>
          <span @click="()=>this.$router.push({name:'exchangeCoupon'})">
            {{$t('label.w128')}}：{{assets.IntegralCount}}
            <div class="dsc">
              <p>{{$t('other.w111')}}</p>
              <p>{{$t('other.w112')}}</p>
            </div>
          </span>
        </div>
        <div class="recordbtn">
          <router-link :to="{name:'moneyRecord'}">{{$t('nav.w12')}}</router-link>
          <a href="javascript:;" @click="freezesOpen">{{$t('btn.b65')}}</a>
        </div>
        <div class="bg-img"></div>
      </div>
      <div class="capital">
        <h3 class="title">{{$t('option.w34')}}</h3>
        <div class="accountdata">
          <Row class="detail" type="flex" justify="center" align="middle">
            <Col span="6">
              <p class="tit org">{{assets.TotalAmount | money}}</p>
              <p>{{$t('label.w166')}}({{$t('label.w5')}})</p>
            </Col>
            <Col span="6">
              <p class="tit">{{assets.AvailableAmount | money}}</p>
              <p>{{$t('label.w168')}}({{$t('label.w5')}})</p>
            </Col>
            <Col span="6">
              <p class="tit">{{assets.FreezedAmount | money}}</p>
              <p>{{$t('label.w169')}}({{$t('label.w5')}})</p>
            </Col>
            <Col span="6" class="withdrawalBtn">
              <router-link :to="{name:'recharge'}" class="btn">{{$t('nav.w9')}}</router-link>
              <router-link :to="{name:'withdraw'}" class="btn bg">{{$t('nav.w10')}}</router-link>
            </Col>
          </Row>
          <div class="award">
            <div class="myaward">
              {{$t('title.w63')}}
              <span
                :style="{color:'#232325'}"
              >￥{{assets.AwardAvailableAmount|money}}</span>
            </div>
            <div class="btn">
              <a v-show="LoanTotalAmount>0" href="javascript:;" @click="changefee">{{$t('nav.w74')}}</a>
              <span v-show="LoanTotalAmount>0">|</span>
              <router-link :to="{name:'withdraw',query:{type:'award'}}">{{$t('nav.w10')}}</router-link>
            </div>
          </div>
          <div class="managementfee" v-show="LoanTotalAmount>0">
            <div class="fee">
              {{$t('label.w172')}}：
              <span
                :style="{color:'#232325'}"
              >￥{{assets.ManagementFeeAvailableAmount | money}}</span>
              （{{$t('label.w173')}}￥{{assets.ThisMonthNeedRepayManagementFee}}）
              <span
                v-if="assets.ManagementFeeFreezedAmount"
                :style="{marginLeft:'20px'}"
              >
                {{$t('label.w174')}}：
                <span
                  :style="{color:'#232325'}"
                >￥{{assets.ManagementFeeFreezedAmount | money}}</span>
              </span>
            </div>
            <div class="btn">
              <router-link :to="{name:'recharge',query:{type:'management'}}">{{$t('nav.w9')}}</router-link>
              <span>|</span>
              <router-link :to="{name:'withdraw',query:{type:'management'}}">{{$t('nav.w10')}}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="investloan">
        <Row class="detail" type="flex" justify="center" align="middle">
          <Col span="12">
            <h3 class="title">{{$t('title.w47')}}</h3>
            <div class="invest loan">
              <p>{{$t('label.w175')}}({{$t('label.w5')}})</p>
              <p class="num">{{ilinfo.ThisMonthCanReceive}}</p>
              <Row class="desc">
                <Col span="8">
                  <p>{{$t('label.w176')}}({{$t('label.w5')}})</p>
                  <p class="boldnum">{{ilinfo.CurrentInvestAmount | money}}</p>
                </Col>
                <Col span="8">
                  <p>{{$t('label.w177')}}({{$t('label.w5')}})</p>
                  <p class="boldnum">{{ilinfo.DueReceiveTotalAmount}}</p>
                </Col>
                <Col span="8">
                  <p>{{$t('label.w178')}}({{$t('label.w5')}})</p>
                  <p class="boldnum">{{ilinfo.TotalIncome | money}}</p>
                </Col>
              </Row>
            </div>
          </Col>
          <Col span="12" class="ss">
            <h3 class="title">{{$t('title.w48')}}</h3>
            <Row class="invest">
              <Col span="14">
                <p>{{$t('label.w179')}}({{$t('label.w5')}})</p>
                <p class="num blue">{{ilinfo.ThisMonthNeedRepay}}</p>
                <Row class="desc">
                  <Col span="8">
                    <p>{{$t('label.w180')}}({{$t('label.w5')}})</p>
                    <p class="boldnum">{{ilinfo.CurrentLoanAmount | money}}</p>
                  </Col>
                  <Col span="8">
                    <p>{{$t('label.w181')}}({{$t('label.w5')}})</p>
                    <p class="boldnum">{{ilinfo.NeedRepayAmount | money}}</p>
                  </Col>
                  <Col span="8" v-show="ilinfo.UnDefaultRepayTotalAmount>0">
                    <p>{{$t('label.w182')}}({{$t('label.w5')}})</p>
                    <p class="boldnum">{{ilinfo.UnDefaultRepayTotalAmount | money}}</p>
                  </Col>
                </Row>
              </Col>
              <Col span="10" class="reimbursement">
                <router-link
                  :to="{name:'creditCycle'}"
                  v-show="ilinfo.IsRevolvingLoan"
                >{{$t('nav.w11')}}</router-link>
                <router-link
                  :to="{name:'loanOrder'}"
                  v-show="ilinfo.NeedRepayAmount>0"
                >{{$t('nav.w70')}}</router-link>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div class="pledge">
        <h3 class="title">{{$t('title.w49')}}</h3>
        <Row class="pledgemsg" type="flex" justify="center" align="middle">
          <Col span="6" class="msg1">
            <p class="num">{{assets.CreditAvailableAmount | money}}</p>
            <p class="fs12">{{$t('label.w184')}}({{$t('label.w5')}})</p>
          </Col>
          <Col span="10" class="msg2">
            <p>
              <span>{{$t('label.w119')}}({{$t('label.w5')}})</span>
              <span>{{assets.CreditTotalAmount | money}}</span>
            </p>
            <p>
              <span>{{$t('label.w185')}}({{$t('label.w183')}})</span>
              <span>{{assets.CreditCount}}</span>
            </p>
            <p>
              <span>{{$t('label.w186')}}({{$t('label.w183')}})</span>
              <span>{{assets.PledgedCount}}</span>
            </p>
          </Col>
          <Col span="8" class="msg3">
            <router-link :to="{name:'applyCredit'}">{{$t('nav.w19')}}</router-link>
            <router-link :to="{name:'domainManage'}">{{$t('nav.w13')}}</router-link>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Freezes from "./modal/freezes";
import Award from "./modal/award";
export default {
  components: { Freezes, Award },
  data() {
    return {
      ilinfo: {},
      freezesModel: false,
      LoanTotalAmount: ""
    };
  },
  created() {
    this.$store.dispatch("user/getUser", "all");
  },
  mounted() {
    this.getData();
    this.isMangement();
  },
  methods: {
    getData() {
      this.$axios.get("/Member/RZJFund/InvestLoanInfo").then(res => {
        if (res.err) return res.throw();
        this.ilinfo = res;
      });
    },
    isMangement() {
      this.$axios.get(" /Member/RZJFund/UserLoanTotalAmount").then(res => {
        if (res.err) return res.throw();
        this.LoanTotalAmount = res.LoanTotalAmount;
      });
    },
    freezesOpen() {
      this.$refs.freezes.modal = true;
    },
    changefee() {
      this.$refs.award.modal = true;
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.user.info;
    },
    assets() {
      return this.$store.state.user.assets;
    }
  }
};
</script>

<style lang="less" scoped>
.assetcenter {
  width: 100%;
  background: #f1f2f5;
  .assetmain {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
      color: rgba(35, 35, 37, 1);
    }
    .header {
      height: 217px;
      width: 100%;
      font-weight: 500;
      position: relative;
      .name {
        font-family: DIN-Medium;
        margin-top: 30px;
        font-size: 24px;
        color: #001955;
      }
      .id {
        font-family: DIN-Medium;
        font-size: 14px;
        margin-top: 10px;
        color: rgba(123, 123, 124, 1);
        span:first-child {
          padding-right: 5px;
        }
        span:last-child {
          padding-left: 5px;
          display: inline-block;
          cursor: pointer;
          position: relative;
          &:hover {
            &::before {
              display: block;
            }
            .dsc {
              display: block;
            }
          }
          a {
            color: rgba(123, 123, 124, 1);
          }
          &::after {
            content: "";
            width: 13px;
            height: 13px;
            background: url("../../assets/assetcenter/asset_more1.png");
            background-size: cover;
            position: absolute;
            right: -20px;
            top: 4px;
          }
          &::before {
            content: "";
            position: absolute;
            display: none;
            left: 15px;
            top: -12px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid rgba(255, 255, 255, 1);
            z-index: 5;
          }
          .dsc {
            display: none;
            position: absolute;
            top: -102px;
            left: -5px;
            width: 256px;
            background: #fff;
            border-radius: 4px;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);

            p:first-child {
              height: 30px;
              line-height: 30px;
              border-bottom: 1px solid #e8e8e8;
              color: rgba(0, 0, 0, 0.85);
              padding-left: 20px;
            }
            p:last-child {
              height: 60px;
              padding-top: 10px;
              color: rgba(0, 0, 0, 0.65);
              padding-left: 20px;
            }
          }
        }
      }
      .recordbtn {
        margin-top: 20px;
        a {
          display: inline-block;
          width: 100px;
          height: 32px;
          border-radius: 6px;
          border: 1px solid rgba(151, 151, 151, 1);
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          line-height: 32px;
          color: #7b7b7c;
        }
        a:first-child {
          margin-right: 20px;
        }
      }
      .bg-img {
        height: 217px;
        width: 619px;
        background: url("../../assets/assetcenter/asset_bg.png") no-repeat;
        background-size: cover;
        position: absolute;
        right: 0;
        top: -30px;
      }
    }
    .capital {
      margin-top: -55px;
      .accountdata {
        .detail {
          height: 122px;
          background: rgba(255, 255, 255, 1);
          border-radius: 8px 8px 0px 0px;
          color: #7b7b7c;
          text-align: center;
          .tit {
            font-size: 36px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(0, 25, 85, 1);
          }
          .org {
            color: rgba(255, 97, 6, 1);
          }
          .withdrawalBtn {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .bg {
              background: linear-gradient(
                90deg,
                rgba(129, 169, 250, 1) 0%,
                rgba(74, 112, 242, 1) 100%
              );
              color: #fff !important;
              margin-top: 10px;
              border: none !important;
            }
            .btn {
              width: 100px;
              height: 32px;
              color: #7b7b7c;
              text-align: center;
              line-height: 32px;
              border-radius: 16px;
              border: 1px solid rgba(151, 151, 151, 1);
            }
          }
        }
        .award {
          display: flex;
          justify-content: space-between;
          background: rgba(233, 234, 238, 1);
          font-size: 14px;
          padding: 10px 56px 0 58px;
          color: rgba(123, 123, 124, 1);
          .myaward {
            margin-bottom: 10px;
          }
          .btn {
            a {
              color: #232325;
            }
            span {
              margin: 0 10px;
            }
          }
        }
        .managementfee {
          background: rgba(233, 234, 238, 1);
          border-radius: 0px 0px 8px 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          padding-bottom: 10px;
          .fee {
            color: rgba(123, 123, 124, 1);
            margin-left: 58px;
          }
          .btn {
            margin-right: 56px;
            a {
              color: #232325;
            }
            span {
              margin: 0 10px;
            }
          }
        }
      }
    }
    .investloan {
      margin-top: 30px;
      .ss {
        padding-left: 10px;
      }
      .invest {
        padding: 30px 0 0 30px;
        height: 220px;
        margin-right: 20px;
        width: 590px;
        color: #7b7b7c;
        background: url("../../assets/assetcenter/asset_card2.png") no-repeat;
        background-size: cover;
        .num {
          font-size: 36px;
          margin-top: 10px;
          font-family: DIN-Medium;
          font-weight: 500;
          color: rgba(255, 97, 6, 1);
        }
        .blue {
          color: #5e8ffc;
        }
        .desc {
          margin-top: 50px;
          .boldnum {
            font-size: 16px;
            font-weight: 500;
            color: rgba(35, 35, 37, 1);
          }
        }
        .reimbursement {
          height: 190px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          a {
            display: block;
            width: 100px;
            height: 32px;
            cursor: pointer;
            text-align: center;
            line-height: 32px;
            color: #7b7b7c;
            border-radius: 16px;
            margin-bottom: 10px;
            border: 1px solid rgba(151, 151, 151, 1);
          }
        }
      }
      .loan {
        background: url("../../assets/assetcenter/asset_card1.png") no-repeat;
        background-size: cover;
      }
    }
    .pledge {
      margin-top: 30px;
      margin-bottom: 50px;
      .pledgemsg {
        height: 120px;
        font-size: 14px;
        color: #7b7b7c;
        background: #fff;
        border-radius: 8px;
        .msg1 {
          text-align: center;
          .num {
            font-size: 36px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(0, 25, 85, 1);
          }
          .fs12 {
            font-size: 12;
          }
        }
        .msg2 {
          padding-left: 180px;
          p {
            margin-bottom: 20px;
            span:first-child {
              display: inline-block;
              width: 100px;
            }
            span:last-child {
              color: #232325;
              padding-left: 56px;
            }
          }
          p:last-child {
            margin-bottom: 0;
          }
        }
        .msg3 {
          height: 84px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          padding-right: 90px;
          a {
            display: block;
            width: 100px;
            height: 32px;
            cursor: pointer;
            text-align: center;
            line-height: 32px;
            color: #7b7b7c;
            border-radius: 16px;
            margin: 5px 0;
            border: 1px solid rgba(151, 151, 151, 1);
          }
        }
      }
    }
  }
}
</style>


